// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProvinceCard_productDetailHeader__Y1UEJ","icons":"ProvinceCard_icons__295pq"};